export default "ui-chart-spline{display:block}\n";